import { render, staticRenderFns } from "./ReleaseSalary.vue?vue&type=template&id=2e61c52a&scoped=true"
import script from "./ReleaseSalary.vue?vue&type=script&lang=js"
export * from "./ReleaseSalary.vue?vue&type=script&lang=js"
import style0 from "./ReleaseSalary.vue?vue&type=style&index=0&id=2e61c52a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e61c52a",
  null
  
)

export default component.exports